import { ArrowUpCircleIcon } from '@heroicons/react/24/outline';
import { SubscriptionTier } from '../../types/firm';
import { Link } from 'react-router-dom';
import { useFirmContext } from '../../providers/FirmProvider';
import { useIsFirmRole } from '../../hooks/use-is-firm-role';

type UpgradeHintProps = {
    message: string;
    plan: SubscriptionTier;
};
function UpgradeHint({ message, plan }: UpgradeHintProps): JSX.Element | null {
    const { shortId, subscription, subscriptionVersion } = useFirmContext();
    const { isAdmin } = useIsFirmRole();

    if (subscriptionVersion !== 1) {
        return null;
    }

    const tier = subscription?.tier;

    const tiers = [SubscriptionTier.BASIC, SubscriptionTier.ESSENTIAL, SubscriptionTier.PROFESSIONAL, SubscriptionTier.ENTERPRISE];

    if (!tier) {
        return null;
    }

    if (tiers.indexOf(tier) >= tiers.indexOf(plan)) {
        return null;
    }

    return (
        <div className="mt-2 flex items-start gap-1">
            <ArrowUpCircleIcon className="h-5 w-5 text-indigo-600" />
            <p className="text-gray-600 text-sm leading-4">
                {isAdmin ? (
                    <Link to={`/${shortId}/settings`} className="text-indigo-600">
                        Upgrade
                    </Link>
                ) : (
                    <label className="text-indigo-600">Upgrade</label>
                )}{' '}
                to the{' '}
                <span>
                    {plan === SubscriptionTier.ESSENTIAL ? (
                        <>
                            <b>Essential</b>
                            {' or '}
                            <b>Professional</b>
                        </>
                    ) : (
                        <b className="capitalize">{plan.toLowerCase()}</b>
                    )}
                </span>{' '}
                plan to {message}.
            </p>
        </div>
    );
}

export default UpgradeHint;
